
import { defineComponent } from 'vue'
import { WebhookEventTypesConnection } from '~/types/types'
import { getHumanizedTimeFromNow } from '~/utils/date'

export default defineComponent({
  name: 'WebhookCard',
  props: {
    id: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    active: {
      type: String,
      required: false
    },
    createdAt: {
      type: String,
      required: true
    },
    modifiedAt: {
      type: String,
      required: true
    },
    eventsSubscribed: {
      type: Object as () => WebhookEventTypesConnection,
      default: () => ({})
    }
  },
  computed: {
    urlHost(): string {
      const url = new URL(this.url)
      return url.hostname
    },
    formattedUrl(): string {
      return this.url.length > 30 ? `${this.url.substr(0, 27)}...` : this.url
    }
  },
  methods: {
    ghtf: getHumanizedTimeFromNow
  }
})
